import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbDialogRef, NbCardModule, NbTabsetModule } from '@nebular/theme';
import { Subscription } from 'rxjs';
import { KPI } from '../../../@core/api';
import { EmissionFactorService } from '../../../@core/utils/emission-factor.service';
import { TranslateModule } from '@ngx-translate/core';
import { AgGridEmissionFactorsComponent } from '../ag-grid-emission-factors/ag-grid-emission-factors.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


@Component({
    selector: 'app-emission-factor-dialog',
    templateUrl: './emission-factor-dialog.component.html',
    styleUrls: ['./emission-factor-dialog.component.scss'],
    standalone: true,
    imports: [NbCardModule, FontAwesomeModule, NbTabsetModule, AgGridEmissionFactorsComponent, TranslateModule]
})
export class EmissionFactorDialogComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  public years = Array.from({ length: 31 }, (_, i) => String(2020 + i));
  public defaultSelectedTab: 'synthesis' | 'emissionFactor' = 'emissionFactor';
  public initialized = false;
  public providerId: number;
  public countryId: number;
  public energyId: number;
  public energyTypeName: string;
  public emissionDetail: KPI.EmissionFactorProvider;
  public emissionFactorByCountryAndYear: KPI.EmissionValueByCountryAndYear[] = [];
  public emissionFactorByYear: KPI.EmissionValueByYear = {};

  constructor(
    private emissionFactorService: EmissionFactorService,
    private ref: NbDialogRef<EmissionFactorDialogComponent>,
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.emissionFactorService.getEmissionFactorsDetailsByCountry(this.providerId).subscribe((emissionDetail: KPI.EmissionFactorProvider) => {
        this.emissionDetail = {
          ...emissionDetail,
          synthese: emissionDetail.synthese?.replace(/\r\n/g, '<br/>') || ''
        };
        if (emissionDetail.based === 'LOCATION') {
          const emissionFactorEnergy = emissionDetail.location_based_emission_factors?.find(nrj => nrj.id === this.energyId);
          this.emissionFactorByCountryAndYear = emissionFactorEnergy.countries.map((country) => ({
            country: country,
            data: this.convertKgToG(country.emission_factors),
          }));
        } else {
          const emissionFactorEnergy = emissionDetail.market_based_emission_factors?.find(nrj => nrj.id === this.energyId);
          this.emissionFactorByYear = this.convertKgToG(emissionFactorEnergy.emission_factors);
        }
      })
    )
  }

  private convertKgToG(map: KPI.EmissionValueByYear): KPI.EmissionValueByYear {
    return Object.keys(map).map((year) => ({
      [year]: map[year] * 1000,
    })).reduce((acc, curr) => ({ ...acc, ...curr }), {});
  }

  public changeTab(): void {
    if (this.initialized) {
      this.defaultSelectedTab = null;
    }
    this.initialized = true;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  public downloadProvider(): void {
    this.emissionFactorService.downloadProvider(this.providerId, this.energyId).subscribe();
  }

  public closeRef(): void {
    this.ref.close();
  }

}
